import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ['tabsContainer', 'topSection'];

	connect() {
		/// observer to check if topSection is out of viewport
		// if so, the table of contents will be sticky on mobile
		const observerTopSection = new IntersectionObserver(this.fixedTabs.bind(this), { threshold: 0.0 });

		observerTopSection.observe(this.topSectionTarget);
	}

	fixedTabs(entries) {
		let reference = this;
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				reference.tabsContainerTarget.classList.remove('sticky');
				reference.tabsContainerTarget.classList.remove('top-0');
				reference.tabsContainerTarget.classList.remove('left-0');
				reference.tabsContainerTarget.classList.remove('bg-neutral-white');
			}
			if (!entry.isIntersecting) {
				reference.tabsContainerTarget.classList.add('sticky');
				reference.tabsContainerTarget.classList.add('top-0');
				reference.tabsContainerTarget.classList.add('left-0');
				reference.tabsContainerTarget.classList.add('bg-neutral-white');
			}
		});
	}
}
